import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { SupportService } from 'src/app/support.service';
import { City } from 'src/typings';
import { CityService } from '../city.service';
import { CreateComponent } from '../create/create.component';

@Component({
  selector: 'app-city-selector',
  templateUrl: './selector.component.html',
  styleUrls: ['./selector.component.scss']
})
export class SelectorComponent {
  constructor(
    private cityService: CityService,
    private notificationService: NotificationService,
    public supportService: SupportService,
    private dialog: MatDialog
  ) {
    this.search();
  }

  cities: City[] = [];

  filteredCities: City[] = [];

  value: any;

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  public displayProperty(city: City) {
    if (city) {
      return city.description;
    } else {
      return '';
    }
  }

  async search() {
    const res = await firstValueFrom(this.cityService.search());
    this.cities = res.data;
    this.filteredCities = res.data;
    //TODO REMOVE ANY
    this.control.valueChanges.subscribe((value: any) => {
      this.filteredCities = this.cities.filter((row) => {
        if (typeof value !== 'string') return true;
        return row.description.toUpperCase().includes(value.toUpperCase());
      });
    });
  }

  onSelect(event: MatAutocompleteSelectedEvent) {
    if (typeof event.option.value === 'string') {
      const dialogRef = this.dialog.open(CreateComponent);
      dialogRef.componentInstance.doneEvent.subscribe(() => {
        dialogRef.componentInstance.cityForm.controls.description.setValue(event.option.value);
        dialogRef.close();
        this.search();
      });
    }
  }
}
